// React
import { useEffect, useState, useRef } from "react";

// Styled Components
import styled from "styled-components";

// Components
import InfoFiveArena from "./InfoFiveArena/InfoFiveArena";

// Model Viewer
import "@google/model-viewer";

// import pinkGlb from "../../../static/videos/pink.glb";
// import pinkUsdz from "../../../static/videos/pink.usdz";

const InfoFive = () => {
  const [mounted, setMounted] = useState(false);
  const viewerRef = useRef(null);

  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    viewerRef.current.addEventListener('ar-status', e => {
      console.log(e.detail);

      if (e.detail.status === 'failed') {
        console.log(`AR failed: ${e.detail.reason}`);
      }
    });
  }, []);

  return (
    <Wrapper>
      <p className="main-header">
        AND HERE IS WHERE THE GAME GETS EVEN MORE INTERESTING...
      </p>

      <InfoFiveArena />

      <div className="section-1">
        <div className="content">
          <p className="header">COMPLETE SHOEUZIS HAVE A NEW SET OF TRAITS.</p>
          <p className="info">
            You will notice new traits on complete shoeuzis, this is because
            complete shoeuzis are playable in the shoeuzi arena. What is the
            shoeuzi arena? Its the multiplayer first person shooter game that we
            are making for the metaverse!
          </p>
          <p className="info">
            We are already negotiating land and developing the game. Your
            complete shoeuzi nfts (along with your others nft pfps/wearables
            etc.) will all be accessible to use in the game.
          </p>
        </div>
        <div className="image">
          <model-viewer
            src={process.env.PUBLIC_URL + '/models/pink.glb'}
            ios-src={process.env.PUBLIC_URL + '/models/pink.usdz'}
            className="model"
            ar
            ar-status="failed"
            alt=""
            auto-rotate
            camera-controls
            ref={viewerRef}
          >
            <div className="error-text" style={{ display: "none" }}>
              AR is not supported on your device.
            </div>
          </model-viewer>

          <div className="specs">
            <div className="spec">
              <p className="spec-header">SHOEUZI</p>
              <p className="info">WANF Pink</p>
            </div>
            <div className="spec">
              <p className="spec-header">RARITY</p>
              <p className="info">Uncommon</p>
            </div>
            <div className="spec">
              <p className="spec-header">PRIMARY FIRE</p>
              <p className="info">SMG</p>
            </div>
            <div className="spec">
              <p className="spec-header">SECONDARY FIRE</p>
              <p className="info">Unfriendly Fire</p>
            </div>
          </div>
        </div>
      </div>

      <div className="section-2">
        <div className="content">
          <p className="header">VR SHOEUZI ARENA</p>
          <p className="info">
            We are also developing a VR version of the game playable on oculus.
            Again, where you can play with the nft shoeuzi you own.
          </p>
        </div>

        <div className="images">
          <img
            src="https://cdn.discordapp.com/attachments/896285560094748713/897899198526140426/Image_14.png"
            alt=""
          />
          <img
            src="https://cdn.discordapp.com/attachments/896285560094748713/897899181455343616/Image_15.png"
            alt=""
          />
        </div>
      </div>
    </Wrapper>
  );
};

export default InfoFive;

const Wrapper = styled.div`
  width: 100%;
  padding: 0 20px;
  margin-top: 400px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 30px;

  position: relative;

  background-color: #000;

  .main-header {
    font-family: "Pixeltype";
    font-weight: 200;

    font-size: 4rem;

    line-height: 96px;

    position: absolute;

    z-index: 10;

    top: -375px;

    //
    width: 920px;
    @media only screen and (max-width: 950px) {
      width: 100%;
      font-size: 2.25rem;
    }
    //
    text-align: center;
  }

  .section-1 {
    padding-top: 50px;
    width: 100%;

    //
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    @media only screen and (max-width: 1075px) {
      flex-direction: column;
      gap: 50px;
    }
    //

    .content {
      //
      width: 520px;
      @media only screen and (max-width: 550px) {
        width: 100%;
      }
      //
      .header {
        font-family: "Pixeltype";
        font-weight: 200;

        line-height: 48px;

        font-size: 2rem;
        //
        width: 520px;
        @media only screen and (max-width: 550px) {
          width: 100%;
        }
        //
        text-align: left;
      }

      .info {
        //
        width: 520px;
        @media only screen and (max-width: 550px) {
          width: 100%;
        }
        //
        color: #8f8f8f;
        font-size: 1.2rem;
        padding-top: 30px;
        text-align: left;

        line-height: 31px;

        color: #fff;
        font-family: "Open Sans", sans-serif;
        font-weight: 300;
      }
    }

    .image {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      model-viewer {
        border: none;
        height: 520px !important;
        //
        width: 520px;
        @media only screen and (max-width: 550px) {
          width: 90vw;
        }
        //
      }

      .specs {
        display: grid;
        grid-template-rows: 1fr 1fr;
        grid-template-columns: 1fr 1fr;

        width: 100%;

        .spec {
          padding: 5px;
          background-color: #000;

          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;

          outline: 1px solid #fff;

          &-header {
            font-size: 0.9rem;
            font-family: interstate, sans-serif;

            font-size: 0.9rem;
            font-family: interstate, sans-serif;
            font-weight: 700;
          }

          .info {
            font-size: 1.25rem;

            font-size: 1.25rem;
            color: #fff;
            font-family: "Open Sans", sans-serif;
            font-weight: 300;
          }
        }
      }
    }
  }

  .section-2 {
    padding-top: 50px;
    width: 100%;

    //
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    @media only screen and (max-width: 1075px) {
      flex-direction: column;
      gap: 50px;
    }
    //

    .content {
      //
      width: 520px;
      @media only screen and (max-width: 550px) {
        width: 100%;
      }
      //
      .header {
        font-family: "Pixeltype";
        font-weight: 200;

        line-height: 48px;

        font-style: normal;
        font-size: 2rem;
        //
        width: 520px;
        @media only screen and (max-width: 550px) {
          width: 100%;
        }
        //
        text-align: left;
      }

      .info {
        //
        width: 520px;
        @media only screen and (max-width: 550px) {
          width: 100%;
        }
        //
        color: #8f8f8f;
        font-size: 1.2rem;
        padding-top: 30px;
        text-align: left;
        line-height: 31px;
        color: #fff;
        font-family: "Open Sans", sans-serif;
        font-weight: 300;
      }
    }

    .images {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 20px;

      img {
        //
        width: 250px;
        @media only screen and (max-width: 550px) {
          width: 50%;
        }
        //
      }
    }
  }
`;
